@if (initialized && kpiHeaderDto) {

    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/ad/config"
    ></kpi-header>


}